angular.module('cfn').directive('dHideInCountry', [
  'userSettingsService',
  function(userSettingsService) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var isoCountry = userSettingsService.getIsoCountryEnum();
        if (isoCountry === attrs.dHideInCountry) {
          element.hide();
        }
      }
    };
  }
]);
